import { render, staticRenderFns } from "./_statisticsTemplate.vue?vue&type=template&id=5daca8d6&scoped=true"
import script from "./_statisticsTemplate.vue?vue&type=script&lang=js"
export * from "./_statisticsTemplate.vue?vue&type=script&lang=js"
import style0 from "./_statisticsTemplate.vue?vue&type=style&index=0&id=5daca8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daca8d6",
  null
  
)

export default component.exports